/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadSOffenderRecord } from './LeadSOffenderRecord';
import {
    LeadSOffenderRecordFromJSON,
    LeadSOffenderRecordFromJSONTyped,
    LeadSOffenderRecordToJSON,
} from './LeadSOffenderRecord';

/**
 * 
 * @export
 * @interface UpdateLeadSOffenderRecordById200Response
 */
export interface UpdateLeadSOffenderRecordById200Response {
    /**
     * 
     * @type {LeadSOffenderRecord}
     * @memberof UpdateLeadSOffenderRecordById200Response
     */
    data?: LeadSOffenderRecord;
}

/**
 * Check if a given object implements the UpdateLeadSOffenderRecordById200Response interface.
 */
export function instanceOfUpdateLeadSOffenderRecordById200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateLeadSOffenderRecordById200ResponseFromJSON(json: any): UpdateLeadSOffenderRecordById200Response {
    return UpdateLeadSOffenderRecordById200ResponseFromJSONTyped(json, false);
}

export function UpdateLeadSOffenderRecordById200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadSOffenderRecordById200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : LeadSOffenderRecordFromJSON(json['data']),
    };
}

export function UpdateLeadSOffenderRecordById200ResponseToJSON(value?: UpdateLeadSOffenderRecordById200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': LeadSOffenderRecordToJSON(value.data),
    };
}

